import { render, staticRenderFns } from "./queryOrder.vue?vue&type=template&id=bbef536a"
import script from "./queryOrder.vue?vue&type=script&lang=js"
export * from "./queryOrder.vue?vue&type=script&lang=js"
import style0 from "./queryOrder.vue?vue&type=style&index=0&id=bbef536a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports